/* eslint-disable no-template-curly-in-string */
import * as Yup from 'yup'
import i18n from '../../i18n'
import { VALIDATION, VALIDATION_MESSAGES } from '../../utils/translation-constants'
import config from 'custom/config/environment'
import validationConfig from 'custom/config/validation.config.json'
const chequeBookConfig = validationConfig['OtherService']['stopCheque']
const chequeStatusConfig = validationConfig['OtherService']['chequeStatus']
const siConfig = validationConfig['OtherService']['standingInstructions']
import moment from 'moment'

const ValidateChequeNo = chequeBookConfig['isChequeNumberRequired']
  ? {
      chequeNumber: Yup.string()
        .matches(new RegExp(config.CHEQUE_NO_LENGTH), i18n.t(VALIDATION_MESSAGES.CHEQUE_NO_LENGTH))
        .when('rangeOfCheques', {
          is: 'INDIVIDUAL',
          then: Yup.string()
            .matches(new RegExp(config.CHEQUE_NO_LENGTH), i18n.t(VALIDATION_MESSAGES.CHEQUE_NO_LENGTH))
            .required(i18n.t(VALIDATION_MESSAGES.CHEQUE_NO)),
          otherwise: Yup.string(),
        }),
    }
  : {
      chequeNumber: Yup.string().optional(),
    }

const validateStartCheque = chequeBookConfig['isStartChequeNoRequired']
  ? {
      startChequeNumber: Yup.string()
        .matches(new RegExp(config.CHEQUE_NO_LENGTH), i18n.t(VALIDATION_MESSAGES.CHEQUE_NO_LENGTH))
        .when('rangeOfCheques', {
          is: 'RANGE',
          then: Yup.string()
            .matches(new RegExp(config.CHEQUE_NO_LENGTH), i18n.t(VALIDATION_MESSAGES.CHEQUE_NO_LENGTH))
            .required(i18n.t(VALIDATION_MESSAGES.START_CHEQUE_NO)),
          otherwise: Yup.string(),
        }),
    }
  : {
      startChequeNumber: Yup.string().optional(),
    }

const validateEndCheque = chequeBookConfig['isEndChequeNoRequired']
  ? {
      endChequeNumber: Yup.string()
        .matches(new RegExp(config.CHEQUE_NO_LENGTH), i18n.t(VALIDATION_MESSAGES.CHEQUE_NO_LENGTH))
        .when('rangeOfCheques', {
          is: 'RANGE',
          then: Yup.string()
            .matches(new RegExp(config.CHEQUE_NO_LENGTH), i18n.t(VALIDATION_MESSAGES.CHEQUE_NO_LENGTH))
            .required(i18n.t(VALIDATION_MESSAGES.END_CHEQUE_NO)),
          otherwise: Yup.string(),
        }),
    }
  : {
      endChequeNumber: Yup.string().optional(),
    }

const validateEffectiveDate = chequeBookConfig['isEffectiveDateRequired']
  ? {
      effectiveDate: Yup.date()
        .required(i18n.t(VALIDATION_MESSAGES.EFFECTIVE_DATE)),
    }
  : {
      effectiveDate: Yup.date().optional(),
    }

const validateRemarks = chequeBookConfig['isRemarksRequired']
  ? {
      remarks: Yup.string()
        .min(2, i18n.t(VALIDATION_MESSAGES.REMARK_VALID))
        .max(40, i18n.t(VALIDATION_MESSAGES.REMARK_VALID))
        .required(i18n.t(VALIDATION_MESSAGES.REMARK)),
    }
  : {
      remarks: Yup.string().optional(),
    }

const ValidateReason = chequeBookConfig['isReasonRequired']
  ? {
      reason: Yup.string().required(i18n.t(VALIDATION_MESSAGES.REASON)),
    }
  : {
      reason: Yup.string().optional(),
    }

const ValidateChequeNumber = chequeStatusConfig['isChequeNoRequired']
  ? {
      chequeNumber: Yup.string()
        .required(i18n.t(VALIDATION_MESSAGES.CHEQUE_NO))
        .matches(new RegExp(config.CHEQUE_NO_LENGTH), i18n.t(VALIDATION_MESSAGES.CHEQUE_NO_LENGTH)),
    }
  : {
      chequeNumber: Yup.string().optional(),
    }

export const ChequeBookRequestSchema = Yup.object().shape({
  // accountNum: Yup.string().required('Account Number Required'),
  pickUpBranch: Yup.string().required(i18n.t(VALIDATION_MESSAGES.PICK_UP_BRANCH)),
  numberOfLeaves: Yup.string().required(i18n.t(VALIDATION_MESSAGES.NO_OF_LEAVES)),
  numberOfBooks:Yup.string().required(i18n.t(VALIDATION_MESSAGES.NO_OF_BOOKS)),
})

export const ChequeStatusSchema = Yup.object().shape({
  ...ValidateChequeNumber,
})

export const StopChequePaymentSchema = Yup.object().shape({
  rangeOfCheques: Yup.string(),
  ...ValidateChequeNo,
  ...validateStartCheque,
  ...validateEndCheque,
  ...validateRemarks,
  ...ValidateReason,
  ...validateEffectiveDate,
})

export const BlockDebitCardSchema = Yup.object().shape({
  // accountNumber: Yup.string().required('Account Number Required'),
  cardNumber: Yup.string().required('Card Number is required'),
  remarks: Yup.string().required('Remarks is required'),
})

export const CardLoadSchema = Yup.object().shape({
  // accountNumber: Yup.string().required('Account Number Required'),
  cardNumber: Yup.string()
    .matches(new RegExp('^[0-9]*$'), 'Numbers Only')
    .required('Card Number is required'),
  currency: Yup.string(),
  amount: Yup.string().required('Amount is required'),
})

export const ChangeCardPINSchema = Yup.object().shape({
  // accountNumber: Yup.string().required('Account Number Required'),
  cardNumber: Yup.number().required('Card Number is required'),
  expiryMonth: Yup.string().required('Expiry Month is required'),
  expiryYear: Yup.string().required('Expiry Year is required'),
  oldPin: Yup.string()
    .required('Old Pin is required')
    .matches(new RegExp('^[0-9]{4}$'), 'Pin Number invalid '),
  newPin: Yup.string()
    .matches(new RegExp('^[0-9]{4}$'), 'Pin Number invalid')
    .required('New Pin is required'),
  confirmNewPin: Yup.string()
    .oneOf([Yup.ref('newPin'), null], 'Pin not matching')
    .required('Confirm Pin is required'),
})

const ValidateRequestType = siConfig['isRequestTypeRequired']
  ? {
      requestType: Yup.string().required(i18n.t(VALIDATION_MESSAGES.REQUEST_TYPE)),
    }
  : {
      requestType: Yup.string().optional(),
    }

const ValidateAccountNO = siConfig['isAccountNoRequired']
  ? {
    creditAccountNumber: Yup.string().when('requestType', {
      is: 'RTGS',
      then: Yup.string().max(20, i18n.t(VALIDATION.OTHER_BANK_ACCOUNT_NO)).required( i18n.t(VALIDATION.CREDIT_ACCOUNT_NUMBER)),
      otherwise: Yup.string()
      .matches(new RegExp(config.ACC_NO_VALIDATION), i18n.t(VALIDATION.REGACCOUNTNOVALID))
      .required(i18n.t(VALIDATION.CREDIT_ACCOUNT_NUMBER)),
    }),
      // creditAccountNumber: Yup.string()
      //   //.min(13, 'Account No. should be 13 digits')
      //   .matches(new RegExp(config.ACC_NO_VALIDATION), i18n.t(VALIDATION.REGACCOUNTNOVALID))
      //   .required('Credit Account No. is required'),
    }
  : {
      creditAccountNumber: Yup.string().optional(),
    }

const ValidateBeneName = siConfig['isAccountNoRequired']
  ? {
      beneficiaryName: Yup.string().when('requestType', {
        is: 'IAT',
        then: Yup.string(),
        otherwise: Yup.string()
          .required(i18n.t(VALIDATION.BENEFICIARYNAME))
          .min(2, i18n.t(VALIDATION.BENEFICIARYNAMEVALID))
          .max(32, i18n.t(VALIDATION.BENEFICIARYNAMEVALID)),
      }),
    }
  : {
      beneficiaryName: Yup.string().optional(),
    }

const ValidateBankName = siConfig['isBankRequired']
  ? {
      bankName: Yup.string().when('requestType', {
        // .when('transferType', {
        is: 'IAT',
        then: Yup.string(),
        otherwise: Yup.string().required(i18n.t(VALIDATION_MESSAGES.BANK_NAME)),
      }),
    }
  : {
      bankName: Yup.string().optional(),
    }

const ValidateBranchName = siConfig['isBranchRequired']
  ? {
      branchName: Yup.string().when('requestType', {
        // .when('transferType', {
        is: 'IAT',
        then: Yup.string(),
        otherwise: config.BENE_BRANCH && Yup.string().required(i18n.t(VALIDATION_MESSAGES.BENIFICIARYBRANCH)),
      }),
    }
  : {
      branchName: Yup.string().optional(),
    }

const ValidateStartDate = siConfig['isStartDateRequired']
  ? {
      startDate: Yup.date()
        .required(VALIDATION_MESSAGES.START_DATE),
    }
  : {
      startDate: Yup.string().optional(),
    }

const ValidateEndDate = siConfig['isEndDateRequired']
  ? {
      endDate: Yup.date()
        .min(Yup.ref('startDate'), VALIDATION_MESSAGES.END_DATE_START_DATE)
        .required(VALIDATION_MESSAGES.END_DATE)
        .test({
          name: "same",
          exclusive: false,
          params: {},
          message: VALIDATION_MESSAGES.END_DATE_START_DATE,
          test: function(value) {
            const startDate = moment(this.parent.startDate).format("YYYY-MM-DD")
            const endDate = moment(value).format("YYYY-MM-DD")
            return !moment(startDate).isSame(moment(endDate))
          },
        }),
    }
  : {
      endDate: Yup.string().optional(),
    }

const ValidateSiAmount = siConfig['isAmountRequired']
  ? {
      siAmount: Yup.string()
        // .matches(new RegExp('^[red1-9][0-9]*$'), 'Instant transfer should not start with 0')
        .required(i18n.t(VALIDATION_MESSAGES.AMOUNT)),
    }
  : {
      siAmount: Yup.string().optional(),
    }

const ValidateRemarks = siConfig['isRemarksRequired']
  ? {
      remarks: Yup.string()
        .min(2, i18n.t(VALIDATION.REMARK_VALID))
        .max(40, i18n.t(VALIDATION.REMARK_VALID))
        .required(i18n.t(VALIDATION.REMARKS)),
    }
  : {
      remarks: Yup.string().optional(),
    }

export const CreateStandingInstructionSchema = Yup.object().shape({
  ...ValidateRequestType,
  ...ValidateAccountNO,
  ...ValidateBankName,
  ...ValidateStartDate,
  ...ValidateEndDate,
  ...ValidateSiAmount,
  ...ValidateRemarks,
  ...ValidateBranchName,
  ...ValidateBeneName,

  date: Yup.number().when('monthEndFlag', {
    is: false,
    then: Yup.number().max(30, 'Invalid Date'),
    otherwise: Yup.number(),
  }),
})


export const DebitCardRequestSchema = Yup.object().shape({
  accountNo: Yup.string().required(VALIDATION_MESSAGES.ACCUNT_NO_REQUIRED),
  deliveryBranch: Yup.string().when('deliveryMode', {
    is: 'BRANCH',
    then:Yup.string().required(VALIDATION.BENIFICIARYBRANCH),
    otherwise: Yup.string(),
  }),
  requestType: Yup.string().required(VALIDATION_MESSAGES.REQUEST_TYPE),
  cardProducts: Yup.string().required(VALIDATION_MESSAGES.CARD_REQUIRED),

})
